var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.274 8.1827C21.6447 8.1827 21.1345 8.69288 21.1345 9.32221V25.6552C21.1345 29.013 18.4149 31.7327 15.0571 31.7327C11.6994 31.7327 8.97971 29.013 8.97971 25.6552V6.66335C8.97971 4.56664 10.6814 2.86497 12.7781 2.86497C14.8748 2.86497 16.5765 4.56664 16.5765 6.66335V22.6165C16.5765 23.4522 15.8928 24.1359 15.0571 24.1359C14.2215 24.1359 13.5378 23.4522 13.5378 22.6165V9.32221C13.5378 8.69288 13.0276 8.1827 12.3983 8.1827V8.1827C11.7689 8.1827 11.2587 8.69288 11.2587 9.32221V22.6165C11.2587 24.7132 12.9604 26.4149 15.0571 26.4149C17.1538 26.4149 18.8555 24.7132 18.8555 22.6165V6.66335C18.8555 3.30558 16.1359 0.585938 12.7781 0.585938C9.42032 0.585938 6.70068 3.30558 6.70068 6.66335V25.6552C6.70068 30.2741 10.4383 34.0117 15.0571 34.0117C19.676 34.0117 23.4136 30.2741 23.4136 25.6552V9.32221C23.4136 8.69288 22.9034 8.1827 22.274 8.1827V8.1827Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.7405c5ea3b4eebf48a0fe51e948acd47.svg";
export { ForwardRef as ReactComponent };